module.exports = __webpack_public_path__ + "static/media/dolly-tsla.a453b705.svg";